import NavHeader from "./NavHeader";
import Footer from "./Footer";
import PageSubtitle from "./PageSubtitle";
import { Layout } from "antd";

const { Content } = Layout;

const MainLayout = ({ children }) => {
  return (
    <Layout
      style={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        backgroundColor: "white",
      }}
    >
      <NavHeader />

      <Content style={{ flex: 1, overflow: "auto", paddingTop: "26px" }}>
        <div className="layout-subtitle-wrapper">
          <PageSubtitle />
        </div>
        {children}
      </Content>

      <Footer />
    </Layout>
  );
};

export default MainLayout;
